/*eslint-disable*/
import React from 'react'
import {
  Flex,
  Link,
  useColorMode,
  useColorModeValue,
} from '@chakra-ui/react'

export default function Footer() {
  const textColor = useColorModeValue('gray.400', 'white')
  const { toggleColorMode } = useColorMode()
  return (
    <Flex
      zIndex='3'
      flexDirection={{
        base: 'column',
        xl: 'row',
      }}
      alignItems={{
        base: 'center',
        xl: 'start',
      }}
      justifyContent='space-between'
      px={{ base: '30px', md: '50px' }}
      pb='30px'
    >
      <div dir='ltr'>
        &copy;2025 - {new Date().getFullYear()} BamyanEntertainment | All Rights
        Reserved.
      </div>
      
      <div>
        Powered by:{' '}
        <Link
          href='https://webifycompany.com' 
          target='_blank'
          rel='noopener noreferrer'
          className='text-primary hover:underline'
          fontWeight={'700'}
        >
          Webify Company
        </Link>
      </div>
    </Flex>
  )
}
